'use strict';

exports.__esModule = true;

var _objectHash = require('./objectHash');

var _objectHash2 = _interopRequireDefault(_objectHash);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Synchronous state container for async data request

var ViasPromise = function () {
  function ViasPromise(model, method, data, options, shape, exec) {
    _classCallCheck(this, ViasPromise);

    this.model = model;
    // Method name
    this.method = method;
    // Data params to resolve this promise
    this.data = data;
    this.options = options;
    // Result shape function
    this.shape = shape;
    this._exec = exec;
    // Do not mark promise to be pending until it start fulfilling
    this.pending = false;
    this.fulfilled = false;
    this.rejected = false;
    this.callbacks = [];
    this.createdAt = new Date();
    if (method && data) {
      // Hash of this promise to easier comparing
      this.id = this.model.name + '_' + this.method + '_' + (0, _objectHash2.default)(this.data);
    }
  }

  ViasPromise.prototype.cacheModel = function cacheModel() {
    return this.model;
  };

  // Populate actual up to date result using alias(es) stored


  ViasPromise.prototype.populate = function populate() {
    var cacheModel = this.cacheModel();
    if (!this.value || !this.cacheModel()) {
      return null;
    }
    var _value = this.value,
        alias = _value.alias,
        result = _value.result;

    if (!alias) {
      return result;
    }

    var aliasPaths = this.shape(result);
    if (!aliasPaths) {
      return cacheModel.fromCache(alias, result);
    } else {
      var populated = (0, _util.clone)(result);
      for (var _iterator = aliasPaths, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var path = _ref;

        var key = (0, _util.pathValue)(result, path);
        (0, _util.setValueByPath)(populated, path, cacheModel.fromCache(alias, key));
      }
      return populated;
    }
  };

  ViasPromise.prototype.setKey = function setKey(key) {
    this.key = key;
    return this;
  };

  ViasPromise.prototype.setPromiseCache = function setPromiseCache(cache) {
    this.promiseCache = cache;
    return this;
  };

  // Fulfil the data request


  ViasPromise.prototype.fulfill = function fulfill() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    options = Object.assign({}, this.options, options);
    if (options.refresh) {
      options.expiry = 0;
    }
    if (this.key && this.promiseCache) {
      var cachedPromise = this.promiseCache[this.key];
      // Copy cached promise to this new promise
      if (!options.refresh && cachedPromise && cachedPromise.id === this.id) {
        this.pending = cachedPromise.pending;
        this.rejected = cachedPromise.rejected;
        this.fulfilled = cachedPromise.fulfilled;
        this.executed = cachedPromise.executed;
        this.reason = cachedPromise.reason;
        this.value = cachedPromise.value;
        this.meta = cachedPromise.meta;
      } else {
        if (cachedPromise && cachedPromise instanceof ViasPromise) {
          this.reason = cachedPromise.reason;
          this.value = cachedPromise.value;
          this.meta = cachedPromise.meta;
        }
        this.promiseCache[this.key] = this;
      }
    }

    // Do not fulfill promise marked executed
    if (this.executed) {
      return this;
    }

    this.pending = true;

    // Mark promise executed so request won't get fulfill again
    this.executed = true;
    if (this.key && this.promiseCache) {
      var _cachedPromise = this.promiseCache[this.key];
      _cachedPromise.executed = true;
    }
    this._exec(options, function (err, result, meta) {
      if (err) {
        _this.reason = err;
        _this.pending = _this.fulfilled = false;
        _this.rejected = true;
        return _this._broadcast();
      }
      if (result || _this.id === 'noop') {
        _this.value = result;
        _this.meta = meta;
        _this.pending = _this.rejected = false;
        _this.fulfilled = true;
        _this._broadcast();
      } else if (options.sync) {
        // Synchronous fulfillment can be fulfill again in case document is not in the cache
        _this.executed = false;
      }
    });

    return this;
  };

  // Re-fulfill promise


  ViasPromise.prototype.refresh = function refresh(options) {
    this.pending = false;
    this.rejected = false;
    this.fulfilled = false;
    this.executed = false;
    this.reason = null;
    this.value = null;
    this.meta = null;
    this.fulfill(Object.assign({ refresh: true }, options));
  };

  ViasPromise.prototype._broadcast = function _broadcast() {
    if (this.pending) {
      return;
    }
    for (var _iterator2 = this.callbacks, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var callback = _ref2;

      if (this.reason) {
        callback(this.reason);
      } else {
        callback(null, this.populate());
      }
    }
    this.callbacks = [];
  };

  ViasPromise.prototype.onFinish = function onFinish(callback) {
    if (this.pending) {
      this.callbacks.push(callback);
    } else if (this.fulfilled) {
      callback(null, this.populate());
    } else if (this.rejected) {
      callback(this.reason);
    }
    return this;
  };

  return ViasPromise;
}();

exports.default = ViasPromise;


//////////////////
// WEBPACK FOOTER
// ./~/vias/lib/ViasPromise.js
// module id = 90
// module chunks = 15